import { DiscussionSortOption } from './types';

export enum DISCUSSION {
  QUESTIONS = 'questions',
  REVIEWS = 'reviews',
}

export enum DEAL_COMMENT_TYPE {
  REVIEW = 'dealreview',
  QUESTION = 'dealcomment',
}

export const QUESTION_SORT_OPTIONS: DiscussionSortOption[] = [
  { value: 'latest', label: 'Latest reply' },
  { value: 'helpful', label: 'Helpful' },
  { value: 'newest', label: 'Newest' },
  { value: 'oldest', label: 'Oldest' },
];

export const REVIEW_SORT_OPTIONS: DiscussionSortOption[] = [
  { value: 'newest', label: 'Newest' },
  { value: 'oldest', label: 'Oldest' },
  { value: 'rating:asc', label: 'Rating (Lowest)' },
  { value: 'rating:desc', label: 'Rating (Highest)' },
  { value: 'helpful', label: 'Helpful' },
];

export const ITEMS_PER_PAGE_ON_DEAL = 5;
export const ITEMS_PER_PAGE_ON_AGGREGATE = 20;
export const REPLY_MAX_LENGTH = 5000;
export const REVIEW_TITLE_MAX_LENGTH = 250;
